import { Label, LabelProps, Text } from "react-aria-components";
import styles from "./FormLabel.module.css";

interface IFormLabel extends LabelProps {
  label: string;
  description?: string;
  isDisabled?: boolean;
}

const FormLabel = ({
  label,
  description,
  isDisabled,
  ...props
}: IFormLabel) => (
  <Label
    className={styles.formLabelContainer}
    aria-disabled={isDisabled}
    {...props}
  >
    <span className={styles.formLabel}>{label}</span>
    {description && (
      <Text className={styles.formDescription} slot="description">
        {description}
      </Text>
    )}
  </Label>
);

export default FormLabel;
